import { render, staticRenderFns } from "./vSuministros.vue?vue&type=template&id=1f4dee2b"
import script from "./vSuministros.vue?vue&type=script&lang=js"
export * from "./vSuministros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports